// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .footer{
    background-color: black;
    height: 31vw;
    display: flex;
    justify-content: center; 
    align-items: center;
    padding: 10% 10% 10% 10%;
  }
  .accent{
    height: 1vw;
    width: 100%;
  }
  .footer-container{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .logo-container{ 
    width: 90%;
    display: flex;
    align-items: end;
    margin-bottom: 11%;
  }
  .ideum-logo{
    height: 8.75vw;
  }
  .wine-ex-div{
    display: flex;
    align-items: center;
    height: 4.75vw;
    padding-left: 5%;
    margin-left: 5%;
    border-left: 1px white solid;
  }
  .line{
    height: 5vw;
    width: 2px;
    border-left: #fdf9f1 1px solid;
    margin: 0 5% 0 5%;
  }
  .wine-experience{
    color: white;
    font-size: 4vw;
    line-height: 4vw;
    margin: 0;
  }
  .social-div{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 92%;
  }
  .link{
    width: 7vw;
    height: 7vw;
    border: 1px white solid;
    padding: 2%;
    margin-left: 4.5%;
    margin-right: 4.5%;
    border-radius: 10vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .social-icon{
    width: 5.25vw;
  }

  @media only screen and (min-width: 700px) and (min-height: 1000px){

    .footer{
      background-color: black;
      height: auto;
      display: flex;
      justify-content: center; 
      align-items: center;
      padding: 5% 10% 7% 10%;
    }
    .accent{
      height: 1vw;
      width: 100%;
    }
    .footer-container{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .logo-container{ 
      width: 90%;
      display: flex;
      align-items: end;
      justify-content: center;
      margin-bottom: 9%;
    }
    .ideum-logo{
      height: 6vw;
    }
    .wine-ex-div{
      display: flex;
      align-items: center;
      height: 2.75vw;
      padding-left: 5%;
      margin-left: 5%;
      border-left: 1px white solid;
    }
    .line{
      height: 5vw;
      width: 2px;
      border-left: #fdf9f1 1px solid;
      margin: 0 5% 0 5%;
    }
    .wine-experience{
      color: white;
      font-size: 3.25vw;
      line-height: 4vw;
      margin: 0;
    }
    .social-div{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 92%;
    }
    .link{
      width: 3.75vw;
      height: 3.75vw;
      border: 1px white solid;
      padding: 2.5%;
      margin-left: 4.25%;
      margin-right: 4.25%;
      border-radius: 10vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .social-icon{
      width: 3.5vw;
    }
  }

  @media only screen and (min-width: 1000px){
    .footer{
      background-color: black;
      height: 13vh;
      display: flex;
      justify-content: center; 
      align-items: center;
      padding: 0 5% 0 5%;
    }
    .accent{
      height: 5px;
      width: 100%;
    }
    .footer-container{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    }
    .logo-container{ 
      width: 100%;
      display: flex;
      align-items: end;
      justify-content: baseline;
      margin-bottom: 0%;
    }
    .ideum-logo{
      height: 30px;
    }
    .wine-ex-div{
      display: flex;
      align-items: center;
      justify-content: baseline;
      height: 18px;
      padding-left: 5%;
      margin-left: 5%;
      border-left: 1px white solid;
    }
    .line{
      height: 20px;
      width: 2px;
      border-left: #fdf9f1 1px solid;
      margin: 0 5% 0 5%;
    }
    .wine-experience{
      color: white;
      font-size: 18px;
      line-height: 24px;
      margin: 0;
    }
    .social-div{
      display: flex;
      align-items: center;
      justify-content: end;
      width: 92%;
    }
    .link{
      width: 26px;
      height: 26px;
      border: 1px white solid;
      padding: 1%;
      margin-left: 14px;
      margin-right: 14px;
      border-radius: 10vw;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .social-icon{
      width: 19px;
    }
  }
  @media screen and (min-width: 1400px){

    .footer{
      background-color: black;
      height: 12vh;
      display: flex;
      justify-content: center; 
      align-items: center;
      padding: 0 6% 0 7%;
    }
    .footer-container{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    }
    .logo-container{ 
      width: 100%;
      display: flex;
      align-items: end;
      justify-content: baseline;
      margin-bottom: 0%;
      margin-top: -.2%;
    }
    .ideum-logo{
      height: 34px;
    }
    .wine-ex-div{
      display: flex;
      align-items: center;
      justify-content: baseline;
      height: 22px;
      padding-left: 5%;
      margin-left: 5%;
      border-left: 1px white solid;
    }
    .line{
      height: 24px;
      width: 2px;
      border-left: #fdf9f1 1px solid;
      margin: 0 5% 0 5%;
    }
    .wine-experience{
      color: white;
      font-size: 18px;
      line-height: 28px;
      margin: 0;
    }
    .social-div{
      display: flex;
      align-items: center;
      justify-content: end;
      width: 92%;
    }
    .link{
      width: 25px;
      height: 25px;
      border: 1px white solid;
      padding: 1%;
      margin-left: 15px;
      margin-right: 15px;
      border-radius: 10vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .social-icon{
      width: 20px;
    }
  }
  @media screen and (min-width: 1900px){

    .footer{
      background-color: black;
      height: 12vh;
      display: flex;
      justify-content: center; 
      align-items: center;
      padding: 0 5% 0 7.5%;
    }
    .accent{
      height: 6px;
      width: 100%;
    }
    .footer-container{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    }
    .logo-container{ 
      width: 100%;
      display: flex;
      align-items: end;
      justify-content: start;
      margin-bottom: 0%;
      margin-top: -.2%;
    }
    .ideum-logo{
      height: 36px;
    }
    .wine-ex-div{
      display: flex;
      align-items: center;
      justify-content: baseline;
      height: 22px;
      padding-left: 5%;
      margin-left: 5%;
      border-left: 1px white solid;
    }
    .line{
      height: 24px;
      width: 2px;
      border-left: #fdf9f1 1px solid;
      margin: 0 5% 0 5%;
    }
    .wine-experience{
      color: white;
      font-size: 20px;
      line-height: 30px;
      margin: 0;
    }
    .social-div{
      display: flex;
      align-items: center;
      justify-content: end;
      width: 92%;
    }
    .link{
      width: 27px;
      height: 27px;
      border: 1px white solid;
      padding: 1%;
      margin-left: 20px;
      margin-right: 20px;
      border-radius: 10vw;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .social-icon{
      width: 22px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"EAAE;IACE,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;;EAEA;;IAEE;MACE,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB;IACxB;IACA;MACE,WAAW;MACX,WAAW;IACb;IACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;IACxB;IACA;MACE,UAAU;MACV,aAAa;MACb,gBAAgB;MAChB,uBAAuB;MACvB,iBAAiB;IACnB;IACA;MACE,WAAW;IACb;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,4BAA4B;IAC9B;IACA;MACE,WAAW;MACX,UAAU;MACV,8BAA8B;MAC9B,iBAAiB;IACnB;IACA;MACE,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,UAAU;IACZ;IACA;MACE,aAAa;MACb,cAAc;MACd,uBAAuB;MACvB,aAAa;MACb,kBAAkB;MAClB,mBAAmB;MACnB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;IACpB;IACA;MACE,WAAW;MACX,WAAW;IACb;IACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;IACnB;IACA;MACE,YAAY;IACd;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,yBAAyB;MACzB,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,4BAA4B;IAC9B;IACA;MACE,YAAY;MACZ,UAAU;MACV,8BAA8B;MAC9B,iBAAiB;IACnB;IACA;MACE,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,oBAAoB;MACpB,UAAU;IACZ;IACA;MACE,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;EACA;;IAEE;MACE,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;IACpB;IACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;MACjB,gBAAgB;IAClB;IACA;MACE,YAAY;IACd;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,yBAAyB;MACzB,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,4BAA4B;IAC9B;IACA;MACE,YAAY;MACZ,UAAU;MACV,8BAA8B;MAC9B,iBAAiB;IACnB;IACA;MACE,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,oBAAoB;MACpB,UAAU;IACZ;IACA;MACE,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,WAAW;IACb;EACF;EACA;;IAEE;MACE,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,oBAAoB;IACtB;IACA;MACE,WAAW;MACX,WAAW;IACb;IACA;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;IAClB;IACA;MACE,YAAY;IACd;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,yBAAyB;MACzB,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,4BAA4B;IAC9B;IACA;MACE,YAAY;MACZ,UAAU;MACV,8BAA8B;MAC9B,iBAAiB;IACnB;IACA;MACE,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,oBAAoB;MACpB,UAAU;IACZ;IACA;MACE,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;IACA;MACE,WAAW;IACb;EACF","sourcesContent":["  .footer{\n    background-color: black;\n    height: 31vw;\n    display: flex;\n    justify-content: center; \n    align-items: center;\n    padding: 10% 10% 10% 10%;\n  }\n  .accent{\n    height: 1vw;\n    width: 100%;\n  }\n  .footer-container{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .logo-container{ \n    width: 90%;\n    display: flex;\n    align-items: end;\n    margin-bottom: 11%;\n  }\n  .ideum-logo{\n    height: 8.75vw;\n  }\n  .wine-ex-div{\n    display: flex;\n    align-items: center;\n    height: 4.75vw;\n    padding-left: 5%;\n    margin-left: 5%;\n    border-left: 1px white solid;\n  }\n  .line{\n    height: 5vw;\n    width: 2px;\n    border-left: #fdf9f1 1px solid;\n    margin: 0 5% 0 5%;\n  }\n  .wine-experience{\n    color: white;\n    font-size: 4vw;\n    line-height: 4vw;\n    margin: 0;\n  }\n  .social-div{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 92%;\n  }\n  .link{\n    width: 7vw;\n    height: 7vw;\n    border: 1px white solid;\n    padding: 2%;\n    margin-left: 4.5%;\n    margin-right: 4.5%;\n    border-radius: 10vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .social-icon{\n    width: 5.25vw;\n  }\n\n  @media only screen and (min-width: 700px) and (min-height: 1000px){\n\n    .footer{\n      background-color: black;\n      height: auto;\n      display: flex;\n      justify-content: center; \n      align-items: center;\n      padding: 5% 10% 7% 10%;\n    }\n    .accent{\n      height: 1vw;\n      width: 100%;\n    }\n    .footer-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n    .logo-container{ \n      width: 90%;\n      display: flex;\n      align-items: end;\n      justify-content: center;\n      margin-bottom: 9%;\n    }\n    .ideum-logo{\n      height: 6vw;\n    }\n    .wine-ex-div{\n      display: flex;\n      align-items: center;\n      height: 2.75vw;\n      padding-left: 5%;\n      margin-left: 5%;\n      border-left: 1px white solid;\n    }\n    .line{\n      height: 5vw;\n      width: 2px;\n      border-left: #fdf9f1 1px solid;\n      margin: 0 5% 0 5%;\n    }\n    .wine-experience{\n      color: white;\n      font-size: 3.25vw;\n      line-height: 4vw;\n      margin: 0;\n    }\n    .social-div{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 92%;\n    }\n    .link{\n      width: 3.75vw;\n      height: 3.75vw;\n      border: 1px white solid;\n      padding: 2.5%;\n      margin-left: 4.25%;\n      margin-right: 4.25%;\n      border-radius: 10vw;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .social-icon{\n      width: 3.5vw;\n    }\n  }\n\n  @media only screen and (min-width: 1000px){\n    .footer{\n      background-color: black;\n      height: 13vh;\n      display: flex;\n      justify-content: center; \n      align-items: center;\n      padding: 0 5% 0 5%;\n    }\n    .accent{\n      height: 5px;\n      width: 100%;\n    }\n    .footer-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n    }\n    .logo-container{ \n      width: 100%;\n      display: flex;\n      align-items: end;\n      justify-content: baseline;\n      margin-bottom: 0%;\n    }\n    .ideum-logo{\n      height: 30px;\n    }\n    .wine-ex-div{\n      display: flex;\n      align-items: center;\n      justify-content: baseline;\n      height: 18px;\n      padding-left: 5%;\n      margin-left: 5%;\n      border-left: 1px white solid;\n    }\n    .line{\n      height: 20px;\n      width: 2px;\n      border-left: #fdf9f1 1px solid;\n      margin: 0 5% 0 5%;\n    }\n    .wine-experience{\n      color: white;\n      font-size: 18px;\n      line-height: 24px;\n      margin: 0;\n    }\n    .social-div{\n      display: flex;\n      align-items: center;\n      justify-content: end;\n      width: 92%;\n    }\n    .link{\n      width: 26px;\n      height: 26px;\n      border: 1px white solid;\n      padding: 1%;\n      margin-left: 14px;\n      margin-right: 14px;\n      border-radius: 10vw;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n    }\n    .social-icon{\n      width: 19px;\n    }\n  }\n  @media screen and (min-width: 1400px){\n\n    .footer{\n      background-color: black;\n      height: 12vh;\n      display: flex;\n      justify-content: center; \n      align-items: center;\n      padding: 0 6% 0 7%;\n    }\n    .footer-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n    }\n    .logo-container{ \n      width: 100%;\n      display: flex;\n      align-items: end;\n      justify-content: baseline;\n      margin-bottom: 0%;\n      margin-top: -.2%;\n    }\n    .ideum-logo{\n      height: 34px;\n    }\n    .wine-ex-div{\n      display: flex;\n      align-items: center;\n      justify-content: baseline;\n      height: 22px;\n      padding-left: 5%;\n      margin-left: 5%;\n      border-left: 1px white solid;\n    }\n    .line{\n      height: 24px;\n      width: 2px;\n      border-left: #fdf9f1 1px solid;\n      margin: 0 5% 0 5%;\n    }\n    .wine-experience{\n      color: white;\n      font-size: 18px;\n      line-height: 28px;\n      margin: 0;\n    }\n    .social-div{\n      display: flex;\n      align-items: center;\n      justify-content: end;\n      width: 92%;\n    }\n    .link{\n      width: 25px;\n      height: 25px;\n      border: 1px white solid;\n      padding: 1%;\n      margin-left: 15px;\n      margin-right: 15px;\n      border-radius: 10vw;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .social-icon{\n      width: 20px;\n    }\n  }\n  @media screen and (min-width: 1900px){\n\n    .footer{\n      background-color: black;\n      height: 12vh;\n      display: flex;\n      justify-content: center; \n      align-items: center;\n      padding: 0 5% 0 7.5%;\n    }\n    .accent{\n      height: 6px;\n      width: 100%;\n    }\n    .footer-container{\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: row;\n    }\n    .logo-container{ \n      width: 100%;\n      display: flex;\n      align-items: end;\n      justify-content: start;\n      margin-bottom: 0%;\n      margin-top: -.2%;\n    }\n    .ideum-logo{\n      height: 36px;\n    }\n    .wine-ex-div{\n      display: flex;\n      align-items: center;\n      justify-content: baseline;\n      height: 22px;\n      padding-left: 5%;\n      margin-left: 5%;\n      border-left: 1px white solid;\n    }\n    .line{\n      height: 24px;\n      width: 2px;\n      border-left: #fdf9f1 1px solid;\n      margin: 0 5% 0 5%;\n    }\n    .wine-experience{\n      color: white;\n      font-size: 20px;\n      line-height: 30px;\n      margin: 0;\n    }\n    .social-div{\n      display: flex;\n      align-items: center;\n      justify-content: end;\n      width: 92%;\n    }\n    .link{\n      width: 27px;\n      height: 27px;\n      border: 1px white solid;\n      padding: 1%;\n      margin-left: 20px;\n      margin-right: 20px;\n      border-radius: 10vw;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    .social-icon{\n      width: 22px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
